export interface StudyDocument {
  id: number;
  fileName: string;
  fileUrl: string;
  observations: string;
  uploadedBy: string;
  createdAt: Date;
  showObservations?: boolean;
}

export interface StudyDocumentResponse {
  id: number;
  file_name: string;
  file_url: string;
  observations: string;
  uploaded_by: {
    id: number;
    fullname: string;
  };
  created_at: string;
}

export interface PaginationInfo {
  current_page: number;
  per_page: number;
  last_page: number;
  total: number;
}

export interface StudiesResponse {
  status: boolean;
  data: StudyDocumentResponse[];
  pagination: PaginationInfo;
  message: string;
}

export interface DeleteStudyResponse {
  status: boolean;
  message: string;
}

export interface StudiesDocumentsParams {
  page: number;
  per_page?: number;
}
